// Default error messages
export const DEFAULT_ERROR_MESSAGE =
  'Tidak dapat memproses, silakan untuk coba lagi nanti. Hubungi admin atau customer service untuk detail lebih lanjut.';

export function getMenuResult(status) {
  let name = '-';
  switch (status) {
    case 'kia':
      name = 'Buku KIA';
      break;
    case 'bmi':
      name = 'Delivery Selected';
      break;
    case 'WAITING_FOR_PAYMENT':
      name = 'Waiting for Payment';
      break;
    case 'PAID':
      name = 'Paid';
      break;
    case 'WAITING_FOR_CONFIRMATION':
      name = 'Waiting For Confirmation';
      break;
    case 'PROCESSING_ITEMS':
      name = 'Processing Item';
      break;
    case 'READY_TO_PICKUP':
      name = 'Ready to Pickup';
      break;
    case 'SHIPPED':
      name = 'Shipped';
      break;
    case 'DELIVERED':
      name = 'Delivered';
      break;
    case 'COMPLETED':
      name = 'Completed';
      break;
    case 'REFUNDED':
      name = 'Refunded';
      break;
    case 'CANCELED':
      name = 'Canceled';
      break;
    case 'EXPIRED':
      name = 'Expired';
      break;
    case 'REJECTED':
      name = 'Rejected';
      break;
    default:
      name = '-';
      break;
  }
  return name;
}

export function getPregnancyInterval(status) {
  let name = '-';
  switch (status) {
    case 0:
      name = '< 2 tahun';
      break;
    case 1:
      name = '2-10 tahun';
      break;
    case 2:
      name = '> 10 tahun';
      break;
    default:
      name = '-';
      break;
  }
  return name;
}

export function patientTypeEnum(id) {
  let name = 'ibuHamil';
  switch (id) {
    case 1:
      name = 'ibuHamil';
      break;
    case 2:
      name = 'baby';
      break;
    case 3:
      name = 'teen';
      break;
    case 4:
      name = 'adult';
      break;
    default:
      name = 'ibuHamil';
      break;
  }
  return name;
}

export function lifeStageType(status, pregnancy = null) {
  let name = 'lansia';
  if (pregnancy) {
    switch (pregnancy) {
      case 'hamil':
        name = 'Ibu Hamil';
        break;
      case 'nifas':
        name = 'Bulin & Bufas';
        break;
      default:
        name = 'Ibu Hamil';
        break;
    }
  } else {
    switch (status) {
      case 'bayi':
        name = 'Bayi';
        break;
      case 'balita':
        name = 'Anak - anak';
        break;
      case 'anak_anak':
        name = 'Anak - anak';
        break;
      case 'remaja':
        name = 'Remaja';
        break;
      case 'dewasa':
        name = 'Dewasa';
        break;
      case 'lansia':
        name = 'Lansia';
        break;
      default:
        name = 'ibu Hamil';
        break;
    }
  }
  return name;
}

export function getHealthSignTitle(result, lifeStageString) {
  const title = [];
  result.forEach((item) => {
    switch (item.menu) {
      case 'bmi':
        if (lifeStageString === 'Ibu Hamil') {
          title.push('BMI Awal Kehamilan');
        } else if (lifeStageString === 'Bayi' || lifeStageString === 'Anak - anak' || lifeStageString === 'Remaja') {
          title.push('BMI/Umur');
        } else {
          title.push('BMI');
        }
        break;
      case 'weight':
        if (lifeStageString === 'Bayi' || lifeStageString === 'Anak - anak') {
          title.push('Berat Badan/Umur');
        } else {
          title.push('Berat Badan');
        }
        break;
      case 'height':
        if (lifeStageString === 'Bayi' || lifeStageString === 'Anak - anak') {
          title.push('Tinggi Badan/Umur');
        } else {
          title.push('Tinggi Badan');
        }
        break;
      case 'weightHeight':
        title.push('Berat Badan/Tinggi Badan');
        break;
      case 'armCircum':
        title.push('Lingkar Lengan');
        break;
      case 'temp':
        title.push('Suhu Tubuh');
        break;
      case 'headCircum':
        title.push('Lingkar Kepala');
        break;
      case 'bloodPressure':
        title.push('Tekanan Darah');
        break;
      case 'pregnancyInterval':
        title.push('Jarak Kehamilan');
        break;
      case 'waistCircum':
        title.push('Lingkar Perut');
        break;
      case 'bloodSugar':
        title.push('Gula Darah');
        break;
      case 'smokingHabbit':
        title.push('Perilaku Merokok');
        break;
      case 'anemia':
        title.push('Anemia');
        break;
      default:
        title.push(item.menu);
        break;
    }
  });
  return title;
}

export function getRiskTitle(result, lifeStage = null) {
  const title = [];
  result.forEach((item) => {
    switch (item.menu) {
      case 'pregnancyInterval':
        title.push('Jarak Kehamilan');
        break;
      case 'pregnancyRisk':
        title.push('Resiko Kehamilan');
        break;
      case 'postpartumRisk':
        title.push('Resiko Nifas');
        break;
      case 'babyRisk':
        if (lifeStage === 'Bayi') {
          title.push('anda Bahaya Pada Bayi');
        } else {
          title.push('Tanda Bahaya Pada Bayi dan Balita');
        }
        break;
      case 'malaria':
        title.push('Malaria');
        break;
      case 'tbcControl':
        title.push('Pengendalian TBC');
        break;
      case 'skilas':
        title.push('Pemeriksaan SKILAS');
        break;
      case 'aks':
        title.push('Pemeriksaan AKS');
        break;
      case 'smokingHabbit':
        title.push('Perilaku Merokok');
        break;
      case 'geriatric':
        title.push('Pemeriksaan Geriatri');
        break;
      case 'ppok':
        title.push('Pemeriksaan PPOK');
        break;
      default:
        title.push(item.menu);
        break;
    }
  });
  return title;
}

export function getReminderTitle(menu, lifeStageString = '') {
  let title = '-';
  switch (menu) {
    case 'kia':
      title = 'KIA';
      break;
    case 'malariaControl':
      title = 'Pengendalian Malaria';
      break;
    case 'pregnancyCheckUp':
      title = 'Pemeriksaan Kehamilan';
      break;
    case 'nutrition':
      // title = 'Konsumsi Vitamin dan Gizi';
      title = 'Nutrisi';
      break;
    case 'mentalHealth':
      // title = 'Pemeriksaan Kesehatan Jiwa';
      title = 'Kesehatan Mental';
      break;
    case 'imunization':
      title = 'Imunisasi';
      break;
    case 'breastfeed':
      if (lifeStageString === 'Bulin & Bufas') {
        title = 'ASI';
      } else {
        title = 'Pemberian ASI Eksklusif';
      }
      break;
    case 'postnatalCheckUp': // ?
      title = 'Pemeriksaan Bayi Setelah Dilahirkan';
      break;
    case 'postpartumCheckUp': // ?
      title = 'Pemeriksaan Setelah Persalinan';
      break;
    case 'anemia':
      // title = 'Pemeriksaan Anemia';
      title = 'Anemia';
      break;
    case 'hypertensionControl':
      // title = 'Pengendalian Hipertensi';
      title = 'Pengendalian Tekanan Darah';
      break;
    case 'diabetesControl':
      title = 'Pengendalian Diabetes';
      break;
    case 'contraception':
      title = 'Kontrasepsi';
      break;
    case 'tbcIdentification':
      title = 'Pengendalian TBC';
      break;
    case 'ppok':
      title = 'Pemeriksaan PPOK';
      break;
    case 'covid':
      title = 'Imunisasi COVID-19';
      break;
    case 'geriatric':
      title = 'Pemeriksaan Geriatri';
      break;
    case 'senseHistory':
      title = 'Skrining Indera';
      break;
    case 'mouth':
      title = 'Mulut dan Gigi';
      break;
    case 'screeningBloodPressure':
      title = 'Skrining Tekanan Darah';
      break;
    case 'screeningBloodSugar':
      title = 'Skrining Gula Darah';
      break;
    case 'screeningNutrition':
      title = 'Skrining Gizi';
      break;
    case 'victimOfViolence':
      title = 'Korban Kekerasan';
      break;
    case 'drug':
      title = 'Penggunaan Obat-obatan';
      break;
    default:
      title = menu;
      break;
  }
  return title;
}

export function getRisks(lifeStageString, result = {}, agemonths = null) {
  let risks = [];
  switch (lifeStageString) {
    case 'Ibu Hamil':
      risks = [
        {
          title: 'Kepala dan Pikiran',
          list: [
            {
              title: 'Demam',
              isChecked: result.isFever,
              desc: 'Demam lebih dari dua hari dengan suhu tubuh ≥ 38°C',
            },
            {
              title: 'Sakit Kepala',
              isChecked: result.isHeadache,
              desc: 'Pusing/sakit kepala berat atau pandangan kabur, disertai maupun tidak disertai oleh bengkak pada kaki, tangan dan wajah',
            },
            {
              title: 'Cemas',
              isChecked: result.isWorried,
              desc: 'Sulit tidur atau cemas berlebih',
            },
          ],
        },
        {
          title: 'Dada',
          list: [
            {
              title: 'Risiko TBC',
              isChecked: result.isPersistentCough,
              desc: 'Batuk lebih dari 2 minggu atau kontak serumah dengan penderita TBC',
            },
            {
              title: 'Berdebar-Debar',
              isChecked: result.isChestPain,
              desc: 'Jantung berdebar-debar atau nyeri di dada',
            },
          ],
        },
        {
          title: 'Perut',
          list: [
            {
              title: 'Nyeri Perut',
              isChecked: result.isStomatchAche,
              desc: 'Nyeri di perut atau kandungan',
            },
            {
              title: 'Gerakan Janin',
              isChecked: result.isNotFeelingFetalMove,
              desc: 'Tidak ada gerakan janin atau kurang dari 10x dalam 12 jam (kehamilan diatas minggu ke-16)',
            },
          ],
        },
        {
          title: 'Area Kelamin',
          list: [
            {
              title: 'Cairan dari Jalan Lahir',
              isChecked: result.isOutFluidFromVagina,
              desc: 'Keluar cairan sangat banyak dan berbau (air ketuban keluar sebelum waktunya dan atau perdarahan pada kehamilan)',
            },
          ],
        },
        {
          title: 'Buang Air Besar (BAB) dan Buang Air Kecil (BAK)',
          list: [
            {
              title: 'Diare',
              isChecked: result.isRecurrentDiarrhea,
              desc: 'BAB cair berulang',
            },
            {
              title: 'Nyeri BAK',
              isChecked: result.isPainWhenUrinating,
              desc: 'Sakit saat kencing atau keluar keputihan atau gatal di daerah kemaluan',
            },
          ],
        },
      ];
      break;
    case 'Bulin & Bufas':
      risks = [
        {
          title: 'Kepala dan Pikiran',
          list: [
            {
              title: 'Demam',
              isChecked: result.isFever,
              desc: 'Demam lebih dari dua hari dengan suhu tubuh ≥ 38°C',
            },
            {
              title: 'Sakit Kepala',
              isChecked: result.isHeadache,
              desc: '',
            },
            {
              title: 'Pandangan Kabur',
              isChecked: result.isBlurredVision,
              desc: '',
            },
            {
              title: 'Gelisah',
              isChecked: result.isWorried,
              desc: 'Ada perasaan bersalah, mudah menangis, kehilangan minat, gelisah, gangguan tidur, gangguan konsentrasi',
            },
          ],
        },
        {
          title: 'Dada',
          list: [
            {
              title: 'Nafas Terganggu',
              isChecked: result.isShortnessBreath,
              desc: 'Nafas pendek dan terengah-engah, nafas dangkal disertai nyeri dada, nafas berat, batuk lebih dari 2 minggu',
            },
            {
              title: 'Jantung Berdebar',
              isChecked: result.isHeartPalpitations,
              desc: '',
            },
            {
              title: 'Nyeri Payudara',
              isChecked: result.isBreastPain,
              desc: 'Payudara bengkak kemerahan disertai nyeri, benjolan disertai nyeri ada keluhan dalam menyusui',
            },
          ],
        },
        {
          title: 'Perut',
          list: [
            {
              title: 'Nyeri Perut',
              isChecked: result.isBellyache,
              desc: 'Darah nifas berbau atau mengalir atau ada nyeri pada perut bawah',
            },
          ],
        },
        {
          title: 'Area Kelamin',
          list: [
            {
              title: 'Perdarahan',
              isChecked: result.isBloody,
              desc: 'Terlihat pada pembalut yang dapat basah dalam 5 menit',
            },
            {
              title: 'Nyeri Kelamin',
              isChecked: result.isGenitalPain,
              desc: 'Area sekitar kelamin bengkak atau nyeri atau ada luka terbuka',
            },
            {
              title: 'Keputihan',
              isChecked: result.isVaginalDischarge,
              desc: 'Keputihan berlebih, berwarna dan berbau',
            },
            {
              title: 'Cairan Lain',
              isChecked: result.isOutOtherFluid,
              desc: 'Keluar cairan dari jalan lahir',
            },
          ],
        },
        {
          title: 'Buang Air Besar (BAB) dan Buang Air Kecil (BAK)',
          list: [
            {
              title: 'Keluhan BAK',
              isChecked: result.isUrinationComplaint,
              desc: 'Tidak bisa BAK, BAK sedikit tapi sering, terasa panas, nyeri panggul, urin keluar tanpa disadari',
            },
          ],
        },
      ];
      break;
    case 'Bayi':
    case 'Anak - anak':
      if (agemonths >= 0 && agemonths <= 1) {
        risks = [
          {
            title: 'Seluruh Tubuh',
            list: [
              {
                title: 'Suhu Tubuh',
                isChecked: result.fever,
                desc: 'Terasa panas (suhu tubuh >38,5ᵒC) atau terasa dingin (suhu tubuh <36,5ᵒC)',
              },
              {
                title: 'Aktivitas',
                isChecked: result.activity,
                desc: 'Tampak lemah/tidak bergerak/menangis atau merintih ',
              },
              {
                title: 'Warna Kulit',
                isChecked: result.skinColor,
                desc: 'Tampak biru di sekitar mulut/tangan/kaki/tampak seperti marmer/tampak pucat/ada tanda-tanda memar di kulit',
              },
              {
                title: 'Kejang',
                isChecked: result.convulsions,
                desc: 'Mata mendelik/tangan menari/mulut mencucu/menangis melengking',
              },
              {
                title: 'Imunisasi',
                isChecked: result.imunization,
                desc: 'Belum mendapat imunisasi Hepatitis B0/Belum mendapat imunisiasi BCG',
              },
              {
                title: 'Penyakit Kulit',
                isChecked: result.skinDisease,
                desc: 'Ada bintil-bintil isi air/bintil-bintil isi nanah',
              },
            ],
          },
          {
            title: 'Kepala',
            list: [
              {
                title: 'Hisapan Bayi',
                isChecked: result.suction,
                desc: 'Tidak mau menghisap/menghisap lemah, muntah susu, muntah cairan warna hijau',
              },
              {
                title: 'Mata',
                isChecked: result.eye,
                desc: 'Mata merah/ada kotoran/bernanah',
              },
            ],
          },
          {
            title: 'Dada',
            list: [
              {
                title: 'Napas',
                isChecked: result.breath,
                desc: 'Sesak/napas cepat/dada tertarik ke dalam',
              },
            ],
          },
          {
            title: 'Perut',
            list: [
              {
                title: 'Tali Pusat',
                isChecked: result.umbilicalCord,
                desc: 'Kemerahan di sekitar tali pusat/bernanah/berbau',
              },
            ],
          },
          {
            title: 'Buang Air Besar (BAB) dan Buang Air Kecil (BAK)',
            list: [
              {
                title: 'Buang Air Besar (BAB)',
                isChecked: result.feses,
                desc: 'Belum BAB lebih dari 48 jam setelah lahir/tidak ada anus/BAB keluar dari lubang di sekitar anus/BAB seperti dempul/BAB lebih sering dan lebih encer',
              },
              {
                title: 'Jumlah dan Warna Air Kencing',
                isChecked: result.urinating,
                desc: 'Jumlah sedikit atau tidak kencing selama 6 jam, warna kuning pekat, kecoklatan atau warna lainnya',
              },
            ],
          },
        ];
      } else {
        risks = [
          {
            title: 'Seluruh Tubuh',
            list: [
              {
                title: 'Demam',
                isChecked: result.fever,
                desc: 'Terasa panas (suhu tubuh >38,5ᵒC) demam denga kejang/demam dengan tanda pendarahan (mimisan/gusi berdarah/ muntah kopi/BAB hitam)',
              },
              {
                title: 'Aktivitas',
                isChecked: result.activity,
                desc: 'Tampak lemah atau tidak bergerak atau menangis seperti merintih',
              },
              {
                title: 'Warna Kulit',
                isChecked: result.skinColor,
                desc: 'Tampak biru di sekitar mulut/tangan/kaki/tampak seperti marmer/tampak pucat/ada tanda-tanda memar di kulit',
              },
            ],
          },
          {
            title: 'Kepala',
            list: [
              {
                title: 'Hisapan Bayi',
                isChecked: result.suction,
                desc: 'Tidak mau menghisap/menghisap lemah, muntah susu, muntah cairan warna hijau',
              },
              {
                title: 'Mata',
                isChecked: result.eye,
                desc: 'Mata merah/ada kotoran/bernanah',
              },
            ],
          },
          {
            title: 'Dada',
            list: [
              {
                title: 'Napas',
                isChecked: result.breath,
                desc: 'Sesak/napas cepat/dada tertarik ke dalam',
              },
              {
                title: 'Batuk',
                isChecked: result.cough,
                desc: 'Batuk dengan bunyi grok..grok…/mengi/menangis meringis',
              },
            ],
          },
          {
            title: 'Perut',
            list: [
              {
                title: 'Pemberian Makanan',
                isChecked: result.givingFood,
                desc: 'Anak tidak mau makan dan atau minum/berat badan tidak naik sesuai pertumbuhan',
              },
            ],
          },
          {
            title: 'Buang Air Besar (BAB) dan Buang Air Kecil (BAK)',
            list: [
              {
                title: 'Diare',
                isChecked: result.feses,
                desc: 'BAB lebih sering dan lebih encer dari biasanya disertai dengan mata cekung/haus minum terus dengan lahap/diare disertai darah',
              },
              {
                title: 'Jumlah dan Warna Air Kencing',
                isChecked: result.urinating,
                desc: 'Jumlah sedikit atau tidak kencing selama 6 jam, warna kuning pekat, kecoklatan atau warna lainnya',
              },
            ],
          },
        ];
      }
      break;
    default:
      risks = [];
      break;
  }
  return risks;
}

export function getRiskTitleFromLifeStage(lifeStageString) {
  let name = '-';
  switch (lifeStageString) {
    case 'Ibu Hamil':
      name = 'Resiko Kehamilan';
      break;
    case 'Bulin & Bufas':
      name = 'Resiko Nifas';
      break;
    case 'Bayi':
    case 'Anak - anak':
      name = 'Tanda Bahaya Pada Bayi dan Balita';
      break;
    default:
      name = '-';
      break;
  }
  return name;
}
